'use client';

import { Stack } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { useState } from 'react';
import { DocumentNotFound, DocumentNotSupported } from '..';
import DownloadLink from './DownloadLink';
import { TDocumentUrl } from './types';

export default function ImageThumbnail({ url, filename }: Readonly<TDocumentUrl>) {
  const [isImageBroken, setIsImageBroken] = useState(false);

  if (!url) {
    return <DocumentNotFound text="Image not found" />;
  }

  return (
    <Stack gap={tokens.spacingBase}>
      {isImageBroken ? (
        <DocumentNotSupported />
      ) : (
        /** We have several environment,
         * as discussed we don't wanna config those hostname in next.config.js,
         * thus we don't use next/Image use native img instead */
        <img
          style={{ borderRadius: tokens.borderRadiusSm, aspectRatio: '25/16' }}
          alt={filename}
          src={url}
          onError={() => setIsImageBroken(true)}
        />
      )}
      <DownloadLink filename={filename} url={url} />
    </Stack>
  );
}
